module.exports = __webpack_public_path__ + "img/manage-research.e4c473b0.png";